import { Components } from "react-markdown";

import "./index.css";

const renderers: Components = {
  a({ node, className, children, ...props }) {
    // Check if the anchor tag contains a YouTube video link
    if (props.href && props.href.startsWith("https://youtu.be/")) {
      const videoId = props.href.split("/").pop(); // Extract video ID from the URL
      return (
        <a
          {...props}
          target="_blank"
          rel="noreferrer noopener"
          style={{
            display: "inline-block",
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          <img
            className="mx-auto flex w-full min-w-[250px] max-w-full rounded"
            src={`https://markdown-videos-api.jorgenkh.no/youtube/${videoId}`}
            alt={videoId}
          />
        </a>
      );
    }
    return (
      <a
        {...props}
        target="_blank"
        rel="noreferrer noopener"
        style={{ display: "inline-block" }}
      >
        {children}
      </a>
    );
  },
  table({ node, children, ...props }) {
    return (
      <table className="table text-secondary" {...props}>
        {children}
      </table>
    );
  },
  img({ node, children, ...props }) {
    return (
      <img
        className="mx-auto flex w-full min-w-[250px] max-w-full rounded"
        {...props}
      >
        {children}
      </img>
    );
  },
  ul({ node, children, ordered, ...props }) {
    return (
      <ul className="m-0 py-2 pl-4 pr-0" {...props}>
        {children}
      </ul>
    );
  },
  ol({ node, children, ordered, ...props }) {
    return (
      <ol className="m-0 py-2 pl-4 pr-0" {...props}>
        {children}
      </ol>
    );
  },
};

export default renderers;
